// extracted by mini-css-extract-plugin
export default {"zoomModal":"w1-z"};